exports.components = {
  "component---src-templates-information-detail-js": () => import("./../../../src/templates/informationDetail.js" /* webpackChunkName: "component---src-templates-information-detail-js" */),
  "component---src-templates-page-js": () => import("./../../../src/templates/page.js" /* webpackChunkName: "component---src-templates-page-js" */)
}

